import { render } from "./RadioField.vue?vue&type=template&id=53818318"
import script from "./RadioField.vue?vue&type=script&lang=js"
export * from "./RadioField.vue?vue&type=script&lang=js"
script.render = render

export default script